import React from "react";

import { SearchComponent } from "@utils/search/@types/searchComponent";

import { SearchPagination } from "@components/Search/SearchResults/StateComponents/Pagination/pagination.container";

const ProductPagination = () => (
    <SearchPagination
        resultListComponent={SearchComponent.PRODUCT_RESULT_LIST}
        paginationComponent={SearchComponent.PRODUCT_PAGINATION}
        hitsPerPageComponent={SearchComponent.PRODUCT_HITS_PER_PAGE}
        numberOfHitsComponent={SearchComponent.PRODUCT_NUMBER_OF_HITS}
    />
);
const ContentPagination = () => (
    <SearchPagination
        resultListComponent={SearchComponent.CONTENT_RESULT_LIST}
        paginationComponent={SearchComponent.CONTENT_PAGINATION}
        hitsPerPageComponent={SearchComponent.CONTENT_HITS_PER_PAGE}
        numberOfHitsComponent={SearchComponent.CONTENT_NUMBER_OF_HITS}
    />
);

export { ProductPagination, ContentPagination };
